import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid2";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import ClientesApi from "api/clientesApi";

const EditClienteModal = ({ open, onClose, cliente, onSuccess }) => {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    identificacion: "",
    tipo_identificacion: "",
    nombres: "",
    apellidos: "",
    email: "",
    direccion: "",
    celular: "",
    tipo_trabajador: "",
    sector_trabajador: "",
    genero: "",
    fecha_nacimiento: "",
    tipo_persona: "",
  });

  useEffect(() => {
    if (cliente) {
      setFormData({
        ...cliente,
      });
    }
  }, [cliente]);

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateEmailInput = (value) => {
    let cleanValue = value.trim();
    cleanValue = cleanValue.toLowerCase();
    cleanValue = cleanValue.replace(/[^a-z0-9@._-]/g, "");
    return {
      value: cleanValue,
      isValid: isValidEmail(cleanValue),
      errorMessage: isValidEmail(cleanValue) ? "" : "Por favor ingrese un Email válido",
    };
  };
  const handleEmailChange = (e) => {
    const result = validateEmailInput(e.target.value);
    const email = result.value;
    setFormData({
      ...formData,
      email: email,
    });
    setError(result.errorMessage);
  };

  const handleDateChange = (newValue) => {
    if (newValue) {
      const year = newValue.$y;
      const month = String(newValue.$M + 1).padStart(2, "0");
      const day = String(newValue.$D).padStart(2, "0");
      //const fecha = `${year}-${month}-${day}`;
      const fecha = `${year}-${month}-${day}`;
      setFormData({
        ...formData,
        fecha_nacimiento: fecha,
      });
    }
  };

  const handleIdentificacionBlur = async () => {
    const identificacion = formData.identificacion;
    if (identificacion.length < 5) {
      setErrors((prev) => ({
        ...prev,
        identificacion: "Debe tener al menos 5 caracteres",
      }));
      return;
    }
    try {
      const response = await ClientesApi.fetchClienteByIdentificacion(identificacion);
      const consCliente = response.data;
      if (consCliente) {
        setErrors((prev) => ({
          ...prev,
          identificacion: "La identificación ya existe, debe ingresar otra.",
        }));
      }
    } catch (error) {
      console.error("Error al verificar acreedor:", error);
      setErrors((prev) => ({
        ...prev,
        identificacion: "Error al verificar la identificación",
      }));
    }
  };

  const handleIdentificacionChange = (e) => {
    const identificacion = e.target.value;
    const cleanValue =
      formData.tipo_identificacion === "NIT"
        ? identificacion.replace(/[^\d-]/g, "").slice(0, 20)
        : identificacion.replace(/\D/g, "").slice(0, 20);
    setFormData((prev) => ({ ...prev, identificacion: cleanValue }));
    setErrors((prev) => ({ ...prev, identificacion: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nombres" || name === "apellidos") {
      const cleanValue = value.replace(/[^a-záéíóúñA-ZÁÉÍÓÚÑ\s]/g, "");
      setFormData((prev) => ({
        ...prev,
        [name]: cleanValue,
      }));
    } else if (name === "celular") {
      const cleanValue = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({
        ...prev,
        [name]: cleanValue,
      }));
    } else {
      const cleanValue = value.trim();
      setFormData((prev) => ({
        ...prev,
        [name]: cleanValue,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (cliente) {
        await ClientesApi.updateCliente(cliente.id, formData);
      }
      onSuccess();
    } catch (error) {
      console.error("Error al guardar los datos del Cliente:", error);
      setError(obtenerMensajeError(error, "Error al guardar los datos del Cliente."));
    }
  };

  const resetState = () => {
    setError(undefined);
    setFormData({
      identificacion: "",
      tipo_identificacion: "",
      nombres: "",
      apellidos: "",
      email: "",
      direccion: "",
      celular: "",
      tipo_trabajador: "",
      sector_trabajador: "",
      genero: "",
      fecha_nacimiento: "",
      tipo_persona: "",
    });
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
      <DialogTitle>{cliente ? "Editar Cliente" : "No tiene Cliente"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo Identificación
              </SuiTypography>
              <Select
                name="tipo_identificacion"
                value={formData.tipo_identificacion}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
                <MenuItem value="NIT">Número de Identificación Tributaria</MenuItem>
                <MenuItem value="CE">Cédula de Extranjería</MenuItem>
                <MenuItem value="PAS">Pasaporte</MenuItem>
                <MenuItem value="OTRO">Otro</MenuItem>
              </Select>
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Identificación
              </SuiTypography>
              <SuiInput
                name="identificacion"
                placeholder={
                  formData.tipo_identificacion === "NIT"
                    ? "123456789-1"
                    : formData.tipo_identificacion === "PAS"
                    ? "Alfanumérico 5-20 caracteres"
                    : "Ingrese máximo 20 dígitos numéricos"
                }
                value={formData.identificacion}
                onChange={handleIdentificacionChange}
                onBlur={handleIdentificacionBlur}
                error={Boolean(errors?.identificacion)}
                fullWidth
                disabled={false}
              />
              {errors?.identificacion && (
                <SuiTypography variant="caption" color="error">
                  {errors?.identificacion}
                </SuiTypography>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Nombres
              </SuiTypography>
              <SuiInput
                name="nombres"
                placeholder="Nombres"
                value={formData.nombres}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Apellidos
              </SuiTypography>
              <SuiInput
                name="apellidos"
                value={formData.apellidos}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                No. Celular
              </SuiTypography>
              <SuiInput
                name="celular"
                placeholder="No. Celular"
                value={formData.celular}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Correo Electrónico
              </SuiTypography>
              <SuiInput
                name="email"
                value={formData.email}
                onChange={handleEmailChange}
                type="email"
                placeholder="Email"
              />
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo Persona
              </SuiTypography>
              <Select
                name="tipo_persona"
                value={formData.tipo_persona}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="Persona Natural No Comerciante">
                  Persona Natural No Comerciante
                </MenuItem>
                <MenuItem value="Persona Natural Pequeño(a) Comerciante">
                  Persona Natural Pequeño(a) Comerciante
                </MenuItem>
              </Select>
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Género
              </SuiTypography>
              <Select
                name="genero"
                value={formData.genero}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="FE">FEMENINO</MenuItem>
                <MenuItem value="MA">MASCULINO</MenuItem>
                <MenuItem value="OTRO">OTRO</MenuItem>
                <MenuItem value="NR">NO RESPONDE</MenuItem>
              </Select>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Sector
              </SuiTypography>
              <Select
                name="sector_trabajador"
                value={formData.sector_trabajador}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="PUBLICO">PUBLICO</MenuItem>
                <MenuItem value="PRIVADO">PRIVADO</MenuItem>
                <MenuItem value="MIXTO">MIXTO</MenuItem>
                <MenuItem value="OTRO">OTRO</MenuItem>
              </Select>
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo Trabajador
              </SuiTypography>
              <Select
                name="tipo_trabajador"
                value={formData.tipo_trabajador}
                onChange={handleChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="INDEPENDIENTE">INDEPENDIENTE</MenuItem>
                <MenuItem value="EMPLEADO(A)">EMPLEADO(A)</MenuItem>
                <MenuItem value="PENSIONADO(A)">PENSIONADO(A)</MenuItem>
              </Select>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Dirección
              </SuiTypography>
              <SuiInput
                name="direccion"
                placeholder="Dirección"
                value={formData.direccion}
                onChange={handleChange}
                multiline
                rows={2}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Fecha Nacimiento
              </SuiTypography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="fecha_nacimiento"
                  value={formData.fecha_nacimiento ? dayjs(formData.fecha_nacimiento) : null}
                  onChange={handleDateChange}
                  format="DD/MM/YYYY"
                  renderInput={(params) => (
                    <SuiInput
                      {...params}
                      placeholder="Fecha de Nacimiento"
                      icon={{
                        component: <CalendarTodayIcon />,
                        direction: "right",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            Registrar
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditClienteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cliente: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default EditClienteModal;
